import {
  FETCH_REFERRALS,
  FETCH_INDUSTRIES,
  FETCH_COMPANY_SIZES,
  FETCH_SCHOOLS,
  FETCH_WORK_RELATIONSHIP,
  SEARCH_SCHOOLS_START,
  GET_PROJECT_DURATIONS_SUCCESS,
  GET_JOB_TYPES_SUCCESS,
  GET_WORK_TYPES_SUCCESS,
  GET_TAX_STATUS_SUCCESS,
  GET_PROJECT_BUDGET_RATE_TYPES,
  CREATE_SCHOOL_SUCESS,
  GET_COMMUTE_CITIES_SUCCESS,
  GET_LEVELS_SUCCESS,
  GET_REFERENCE_RELATIONSHIPS_SUCCESS,
  GET_COMPANY_BUDGETS_SUCCESS,
  GET_COMPANY_PAYMENT_METHODS_SUCCESS,
  GET_COMPANY_PAYMENT_TERMS_SUCCESS
} from "../actions/dropdowns.actions";

const INITIAL_STATE = {
  referrals: [],
  industries: [],
  companySizes: [],
  schools: [],
  workRelationship: [],
  projectDurations: [],
  jobTypes: [],
  workTypes: [],
  taxStatus: [],
  projectBudgetRateTypes: [],
  createdSchools: [],
  isLoading: false,
  commuteCities: [],
  levels: [],
  referenceRelationships: [],
  companyBudgets: [],
  companyPaymentMethods: [],
  companyPaymentTerms: []
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FETCH_REFERRALS:
      return { ...state, referrals: action.data };
    case FETCH_INDUSTRIES:
      return { ...state, industries: action.data };
    case FETCH_COMPANY_SIZES:
      return { ...state, companySizes: action.data };
    case SEARCH_SCHOOLS_START:
      return { ...state, isLoading: true };
    case FETCH_SCHOOLS:
      return { ...state, schools: action.data, isLoading: false };
    case FETCH_WORK_RELATIONSHIP:
      return { ...state, workRelationship: action.data };
    case GET_PROJECT_DURATIONS_SUCCESS:
      return { ...state, projectDurations: action.data };
    case GET_JOB_TYPES_SUCCESS:
      return { ...state, jobTypes: action.data };
    case GET_WORK_TYPES_SUCCESS:
      return { ...state, workTypes: action.data };
    case GET_TAX_STATUS_SUCCESS:
      return { ...state, taxStatus: action.data };
    case GET_PROJECT_BUDGET_RATE_TYPES:
      return { ...state, projectBudgetRateTypes: action.data };
    case CREATE_SCHOOL_SUCESS:
      return {
        ...state,
        createdSchools: [action.data].concat(state.createdSchools)
      };
    case GET_COMMUTE_CITIES_SUCCESS:
      return { ...state, commuteCities: action.data };
    case GET_LEVELS_SUCCESS:
      return { ...state, levels: action.data };
    case GET_REFERENCE_RELATIONSHIPS_SUCCESS:
      return { ...state, referenceRelationships: action.data };
    case GET_COMPANY_BUDGETS_SUCCESS:
      return { ...state, companyBudgets: action.data };
    case GET_COMPANY_PAYMENT_METHODS_SUCCESS:
      return { ...state, companyPaymentMethods: action.data };
    case GET_COMPANY_PAYMENT_TERMS_SUCCESS:
      return { ...state, companyPaymentTerms: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dropdowns.reducer.js